<template>
  <div class="section notice-list">
    <div class="h-tt">
      <h2>公告列表</h2>
      <a
        href="javascript:;"
        class="more"
        @click="
          goRoute(`notice/list?type=${cur}`)
          reportTab('more')
        "
        >更多</a
      >
    </div>
    <div class="box">
      <Tab
        :list="tabs"
        @change="
          cur = $event
          reportTab()
        "
      />
      <div class="swiper-container">
        <div
          class="swiper-wrapper"
          :style="`transform: translateX(-${646 * cur}px)`"
        >
          <div v-for="(curArr, i) in arrs" :key="i" class="swiper-slide">
            <template v-if="curArr && curArr.length">
              <div
                class="tit"
                @click="
                  goRoute(`notice/${curArr[0].id}`)
                  reportItemClick(curArr[0].id, curArr[0].title, 1)
                "
              >
                [{{ resType(curArr[0]) }}]{{ curArr[0].title }}
              </div>
              <ul>
                <li
                  v-for="item in curArr.slice(1)"
                  :key="item.id"
                  @click="
                    goRoute(`notice/${item.id}`)
                    reportItemClick(item.id, item.title, 0)
                  "
                >
                  <a href="javascript:;">
                    <em>[{{ resType(item) }}]{{ item.title }}</em>
                    <span>{{ convertTime(item) }}</span>
                  </a>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Tab from '../common/Tab'
import { ResType } from '~/constant'
export default {
  components: {
    Tab
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      cur: 0,
      swiper: null,
      tabs: [
        { title: '综合', type: 0, tab: 'Integrated' },
        { title: '公告', type: 1, tab: 'notice' },
        { title: '活动', type: 2, tab: 'activity' },
        { title: '攻略', type: 3, tab: 'strategy' }
      ],
      arrs: [this.list.slice(0, 5)]
    }
  },
  watch: {
    cur(val) {
      if (val && !this.arrs[val]) {
        this.$request('gameHomeRes', {
          body: {
            game_id: this.$route.params.game_id,
            res_type: val,
            page: 1,
            page_size: 5
          }
        }).then((data = {}) => {
          this.$set(this.arrs, val, data.list || [])
        })
      }
    }
  },
  mounted() {
    this.$xlaGamePush('home_notice_module_show', {
      tab: this.tabs[this.cur].tab
    })
  },
  methods: {
    goRoute(path) {
      this.$router.push(`/game-offical/${this.$route.params.game_id}/${path}`)
    },
    reportItemClick(notice_id, text, is_headline) {
      this.$xlaGamePush('home_notice_item_click', {
        game_id: this.$route.params.game_id,
        tab: this.tabs[this.cur].tab,
        text,
        is_headline,
        notice_id
      })
    },
    reportTab(click_id) {
      const tab = this.tabs[this.cur].tab
      this.$xlaGamePush('home_notice_module_click', {
        tab,
        click_id: click_id || tab
      })
    },
    resType({ res_type }) {
      return ResType[res_type]
    },
    convertTime({ published_at }) {
      return dayjs(published_at).format('MM-DD')
    }
  }
}
</script>
